import React, { useState } from "react";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DashboardLayout from "../../components/SharedLayouts/DashboardLayout";
import BackArrow2 from "../../components/BackArrow2";
import StockForm, { booleanOptions, trendOptions } from "./StockForm";
import { buildStockFormData } from "./buildStockFormData";
import { createStock } from "../../store/actions/stocks/createStock";
import { createStockSchema } from "../../Helper/validationSchemas";

function CreateStock() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [logo, setLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const loading = useSelector((state) => state?.stocks?.createPending) || false;

  const form = useFormik({
    initialValues: {
      symbol: "",
      name: "",
      currency: { value: "NGR", label: "Nigerian Naira (₦)" },
      current_price: "",
      available_volume: "",
      percent_change: 0,
      trend: trendOptions[2],
      description: "",
      sector: "",
      logo_url: "",
      min_volume: 1,
      // min_price: "0",
      // max_price: "0",
      is_active: booleanOptions[0],
      is_shariah_compliant: booleanOptions[0],
    },
    validationSchema: createStockSchema,
    onSubmit: (values, { setSubmitting }) => {
      const data = buildStockFormData(values, logo);
      dispatch(createStock({ data, navigate, setSubmitting }));
    },
  });

  return (
    <DashboardLayout>
      <div className="px-2 lg:px-8">
        <div className="flex items-center mb-8 flex-row md:items-center">
          <Link to={"/dashboard"}>
            <img src="/Assets/bread.png" alt="" className="w-8 h-8 mr-2" />
          </Link>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
          <Link
            to="/stocks"
            className="font-semibold text-[#475467] text-base flex"
          >
            Stocks
          </Link>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 md:mr-2" />
          <span className="font-semibold text-[#475467] text-base bg-[#F9FAFB] p-1 rounded-md">
            Create
          </span>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center mt-8 mb-4 md:mb-6">
          <h1 className="font-semibold text-xl md:text-2xl w-full">
            Create New Stock
          </h1>
        </div>
        <BackArrow2 mb={20} ml={0} />

        <StockForm
          form={form}
          loading={loading}
          submitLabel="Create Stock"
          logo={logo}
          setLogo={setLogo}
          logoPreview={logoPreview}
          setLogoPreview={setLogoPreview}
          onCancel={() => navigate(-1)}
        />
      </div>
    </DashboardLayout>
  );
}

export default CreateStock;
